<div class="d2c-loading" *ngIf="formLoading">
  <div class="d2c-spinner"></div>
  <div class="d2c-loading-txt">Loading form…</div>
</div>

<!-- ===================== header ===================== -->
<div class="cfg-h">
  <div class="d2c-title">
    <span class="d2c-solution-name">{{ activeSolution['solution_name'] }}</span>
    <span class="d2c-version-chip">{{ activeVersion['version_name'] }}</span>
  </div>
  <span class="cfg-h-spacer"></span>
  <button class="btn-ghost" (click)="resetForm()">Reset</button>
  <button class="cfg-x" (click)="closeDialogForm()" aria-label="Close form">
    <mat-icon>close</mat-icon>
  </button>
</div>

<!-- ===================== body: rail / canvas / preview ===================== -->
<div class="cfg-body">
  <!-- section rail -->
  <nav class="cfg-rail" aria-label="Form sections">
    <div class="cfg-rail-l">Form sections</div>
    <button
      *ngFor="let s of sections"
      class="cfg-nav"
      [class.active]="activeSection === s.id"
      (click)="scrollToSection(canvas, s.id)"
    >
      <span class="sn">{{ s.n }}</span>
      <span class="cfg-nav-t">{{ s.title }}</span>
      <span class="scount" *ngIf="!s.optional">{{ sectionCount(s.id) }}</span>
      <span class="opt-tag" *ngIf="s.optional">Optional</span>
    </button>
  </nav>

  <!-- scrolling canvas -->
  <div class="cfg-canvas" #canvas (scroll)="onCanvasScroll(canvas)">
    <!-- --------------------------- Step 1 ------------------------ -->
    <section class="sect" id="cfg-s1">
      <div class="sect-h">
        <span class="step-tag">Step 1</span>
        <h3>Datasets</h3>
      </div>
      <p class="sect-s">
        The datasets this version uses. Add more, or set validation rules.
      </p>
      <div class="sect-b">
        <div class="d2c-addbar">
          <mat-form-field class="d2c-field addbar-field">
            <mat-label>Add datasets</mat-label>
            <mat-select [(ngModel)]="selectUnusedDataset" multiple>
              <mat-select-trigger>
                {{ selectUnusedDataset?.length || 0 }} selected
              </mat-select-trigger>
              <ng-container *ngFor="let data of availableAllDataset">
                <mat-option
                  *ngIf="
                    !isDataSetAlreadyExist(
                      data.data_name,
                      usedDatasetsInVersion
                    )
                  "
                  [value]="data.id"
                >
                  {{ data.data_name }}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
          <button
            class="btn-ghost"
            [disabled]="!selectUnusedDataset?.length"
            (click)="addUnusedDatasets()"
          >
            <mat-icon>add</mat-icon>
            Add{{ selectUnusedDataset?.length ? ' (' + selectUnusedDataset.length + ')' : '' }}
          </button>
        </div>

        <div *ngIf="usedDatasetsInVersion">
          <div class="d2c-chips">
            <mat-chip-set>
              <mat-chip
                *ngFor="let data of usedDatasetsInVersion; let i = index"
              >
                <span class="text-base">
                  {{ data.data_name }}
                  <mat-icon
                    *ngIf="
                      !isDataSetAlreadyExist(
                        data.data_name,
                        basicDatasetUsedInVersion
                      )
                    "
                    class="d2c-chip-x"
                    style="height:16px; width:16px"
                    (click)="removeAddedDataset(i)"
                  >close</mat-icon
                  >
                </span>
              </mat-chip>
            </mat-chip-set>
          </div>

          <table mat-table [dataSource]="usedDatasetsInVersion" class="tbl">
            <ng-container matColumnDef="source_id__connection_type_id">
              <th mat-header-cell *matHeaderCellDef>#</th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ i + 1 }}
              </td>
            </ng-container>

            <ng-container matColumnDef="data_name">
              <th mat-header-cell *matHeaderCellDef>Dataset</th>
              <td mat-cell *matCellDef="let element">
                {{ element.data_name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="category">
              <th mat-header-cell *matHeaderCellDef>Validation</th>
              <td mat-cell *matCellDef="let element">
                <button
                  class="btn-ghost"
                  (click)="addDataSetValidationConfig(element)"
                >
                  {{
                    checkAddedValidation(element.data_name)
                      ? 'Update validation'
                      : '+ Add validation'
                  }}
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
            <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
          </table>
        </div>
      </div>
    </section>

    <!-- --------------------------- Step 2 ------------------------ -->
    <section class="sect" id="cfg-s2">
      <div class="sect-h">
        <span class="step-tag">Step 2</span>
        <h3>Column mappings</h3>
      </div>
      <p class="sect-s">
        Ask the customer which column in their data maps to what you need. Each
        question becomes a dropdown of their columns.
      </p>
      <div class="sect-b">
        <div class="maprow" *ngFor="let element of jsonDataStep2; let i = index">
          <span
            class="rmv"
            *ngIf="jsonDataStep2.length > 1"
            (click)="removeField(jsonDataStep2, i)"
          >
            <mat-icon>close</mat-icon>
          </span>
          <div class="maptag">Mapping {{ i + 1 }}</div>
          <div class="grid4">
            <mat-form-field class="d2c-field">
              <mat-label>Question shown to customer</mat-label>
              <input
                matInput
                placeholder="Which column holds…?"
                required
                [(ngModel)]="element['question']"
              />
            </mat-form-field>

            <mat-form-field class="d2c-field">
              <mat-label>Dataset</mat-label>
              <mat-select [(ngModel)]="element['datasetname']" required>
                <mat-select-trigger class="select-trigger">
                  <span>
                    {{ element['datasetname'] }}
                  </span>
                </mat-select-trigger>
                <mat-option
                  *ngFor="let data of usedDatasetsInVersion"
                  [value]="data['data_name']"
                >{{ data['data_name'] }}
                </mat-option
                >
              </mat-select>
            </mat-form-field>

            <mat-form-field class="d2c-field">
              <mat-label>Column</mat-label>
              <mat-select [(ngModel)]="element['column']" required>
                <mat-select-trigger class="select-trigger">
                  <span>
                    {{ element['column'] }}
                  </span>
                </mat-select-trigger>
                <mat-option
                  *ngFor="
                    let data of getColumnsForADataset(element['datasetname'])
                  "
                  [value]="data"
                >{{ data }}
                </mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <button class="btn-ghost" (click)="add_new_question()">
          <mat-icon>add</mat-icon>
          Add question
        </button>
      </div>
    </section>

    <!-- --------------------------- Step 3 ------------------------ -->
    <section class="sect" id="cfg-s3">
      <div class="sect-h">
        <span class="step-tag">Step 3</span>
        <h3>Run inputs</h3>
      </div>
      <p class="sect-s">
        Expose pipeline arguments as form fields. The customer's answer is
        written into the node's args when they save or run.
      </p>
      <div class="sect-b">
        <div class="maprow" *ngFor="let element of jsonDataStep3; let i = index">
          <span
            class="rmv"
            *ngIf="jsonDataStep3.length > 1"
            (click)="removeField(jsonDataStep3, i)"
          >
            <mat-icon>close</mat-icon>
          </span>
          <div class="maptag">Input {{ i + 1 }}</div>
          <div class="grid5">
            <mat-form-field class="d2c-field">
              <mat-label>Prompt shown to customer</mat-label>
              <input
                matInput
                placeholder="e.g. Target margin %"
                required
                [(ngModel)]="element['prompt']"
              />
            </mat-form-field>

            <mat-form-field class="d2c-field">
              <mat-label>Dataset</mat-label>
              <mat-select [(ngModel)]="element['dataset']" multiple required>
                <mat-select-trigger class="select-trigger">
                  <span>
                    {{ element['dataset'] }}
                  </span>
                </mat-select-trigger>
                <mat-option
                  *ngFor="let data of usedDatasetsInVersion"
                  [value]="data['data_name']"
                >{{ data['data_name'] }}
                </mat-option
                >
              </mat-select>
            </mat-form-field>

            <mat-form-field class="d2c-field">
              <mat-label>Node</mat-label>
              <mat-select [(ngModel)]="element['node']" required>
                <mat-select-trigger class="select-trigger">
                  <span>
                    {{ getNodeName(element['node']) }}
                  </span>
                </mat-select-trigger>
                <mat-option
                  *ngFor="let node of usedNodesInVersion"
                  [value]="node['node_id']"
                >{{ node['node_name'] }}
                </mat-option
                >
              </mat-select>
            </mat-form-field>

            <mat-form-field class="d2c-field">
              <mat-label>Input field</mat-label>
              <mat-select [(ngModel)]="element['field']" multiple required>
                <mat-select-trigger class="select-trigger">
                  <span>
                    {{ element['field'] }}
                  </span>
                </mat-select-trigger>
                <mat-option
                  *ngFor="let data of getInputFieldsInNodes(element['node'])"
                  [value]="data"
                >{{ data }}
                </mat-option
                >
              </mat-select>
            </mat-form-field>

            <mat-form-field class="d2c-field">
              <mat-label>Field type</mat-label>
              <mat-select [(ngModel)]="element['fieldType']" required>
                <mat-select-trigger class="select-trigger">
                  <span>
                    {{ element['fieldType'] }}
                  </span>
                </mat-select-trigger>
                <mat-option
                  *ngFor="let data of fieldDataType"
                  [value]="data"
                >{{ data }}
                </mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>

          <div class="bind" *ngIf="element['node']">
            Writes to
            <span class="bchip">{{
                getNodeName(element['node']) || 'node'
              }}</span>
            <span class="arr">→</span>
            <span class="bchip">args · {{ fieldLabel(element['field']) }}</span>
            <span class="ftpill" *ngIf="element['fieldType']">{{
                element['fieldType']
              }}</span>
          </div>
        </div>

        <button class="btn-ghost" (click)="add_new_algo()">
          <mat-icon>add</mat-icon>
          Add run input
        </button>
      </div>
    </section>

    <!-- --------------------------- Step 4 ------------------------ -->
    <section class="sect" id="cfg-s4">
      <div class="sect-h">
        <span class="step-tag">Step 4</span>
        <h3>Schedule</h3>
      </div>
      <p class="sect-s">
        Optional — run a project automatically on a schedule.
      </p>
      <div class="sect-b">
        <form [formGroup]="scheduleForm">
          <div formArrayName="schedules">
            <div
              class="maprow"
              *ngFor="let schedule of schedules.controls; let i = index"
              [formGroupName]="i"
            >
              <span class="rmv" (click)="removeSchedule(i)">
                <mat-icon>close</mat-icon>
              </span>
              <div class="maptag">Schedule {{ i + 1 }}</div>

              <div class="grid4">
                <mat-form-field class="d2c-field">
                  <mat-label>Project</mat-label>
                  <mat-select formControlName="project">
                    <mat-option
                      *ngFor="let project of availableProjectInVersion"
                      [value]="project"
                    >{{ project?.project_name }}
                    </mat-option
                    >
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="d2c-field">
                  <mat-label>Schedule by</mat-label>
                  <mat-select
                    formControlName="scheduleBy"
                    (selectionChange)="
                      onScheduleByChange(schedule, $event.value, 'scheduleBy')
                    "
                  >
                    <mat-option value="pipeline">Pipeline</mat-option>
                    <mat-option value="tags">Tags</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field
                  class="d2c-field"
                  *ngIf="schedule.get('scheduleBy')?.value === 'pipeline'"
                >
                  <mat-label>Pipeline</mat-label>
                  <mat-select
                    formControlName="pipeline"
                    multiple
                    [compareWith]="comparePipelines"
                  >
                    <mat-option
                      *ngFor="
                        let pipeline of pipelinesMap[
                          schedule.get('project')?.value?.project_id
                        ]
                      "
                      [value]="pipeline"
                    >
                      {{
                        pipeline?.pipeline_name_display
                          ? pipeline?.pipeline_name_display
                          : pipeline?.pipeline_name
                      }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field
                  class="d2c-field"
                  *ngIf="schedule.get('scheduleBy')?.value === 'tags'"
                >
                  <mat-label>Tags</mat-label>
                  <mat-select formControlName="tags" multiple>
                    <mat-option
                      *ngFor="
                        let tag of tagsMap[
                          schedule.get('project')?.value?.project_id
                        ]
                      "
                      [value]="tag"
                    >
                      {{ tag }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="d2c-fullrow">
                <mat-form-field class="d2c-field">
                  <mat-label>Question shown to customer</mat-label>
                  <input matInput formControlName="question" type="text" required />
                </mat-form-field>
              </div>
            </div>
          </div>

          <button class="btn-ghost" (click)="addSchedule()">
            <mat-icon>add</mat-icon>
            Add project
          </button>
        </form>
      </div>
    </section>

    <!-- --------------------------- Step 5 ------------------------ -->
    <section class="sect" id="cfg-s5">
      <div class="sect-h">
        <span class="step-tag">Step 5</span>
        <h3>Event triggers</h3>
      </div>
      <p class="sect-s">
        Optional — auto-run when a customer uploads a file.
      </p>
      <div class="sect-b">
        <form [formGroup]="eventTriggerForm">
          <div formArrayName="triggers">
            <div
              class="maprow"
              *ngFor="let etrigger of eventTrigger.controls; let i = index"
              [formGroupName]="i"
            >
              <span class="rmv" (click)="removeTriggers(i)">
                <mat-icon>close</mat-icon>
              </span>
              <div class="maptag">Trigger {{ i + 1 }}</div>

              <div class="grid5">
                <mat-form-field class="d2c-field">
                  <mat-label>Project</mat-label>
                  <mat-select
                    formControlName="project"
                    [compareWith]="compareProjectById"
                  >
                    <mat-option
                      *ngFor="let project of availableProjectInVersion"
                      [value]="project"
                    >{{ project?.project_name }}
                    </mat-option
                    >
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="d2c-field">
                  <mat-label>Trigger by</mat-label>
                  <mat-select
                    formControlName="trigger_by_pipeline_or_tags"
                    (selectionChange)="
                      onScheduleByChange(
                        etrigger,
                        $event.value,
                        'trigger_by_pipeline_or_tags'
                      )
                    "
                  >
                    <mat-option value="pipeline">Pipeline</mat-option>
                    <mat-option value="tags">Tags</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field
                  class="d2c-field"
                  *ngIf="
                    etrigger.get('trigger_by_pipeline_or_tags')?.value ===
                    'pipeline'
                  "
                >
                  <mat-label>Pipeline</mat-label>
                  <mat-select
                    formControlName="pipelines_or_tags"
                    [compareWith]="comparePipelines"
                    multiple
                  >
                    <mat-option
                      *ngFor="
                        let pipeline of pipelinesMap[
                          etrigger.get('project')?.value?.project_id
                        ]
                      "
                      [value]="pipeline"
                    >
                      {{
                        pipeline?.pipeline_name_display
                          ? pipeline?.pipeline_name_display
                          : pipeline?.pipeline_name
                      }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field
                  class="d2c-field"
                  *ngIf="
                    etrigger.get('trigger_by_pipeline_or_tags')?.value ===
                    'tags'
                  "
                >
                  <mat-label>Tags</mat-label>
                  <mat-select formControlName="pipelines_or_tags" multiple>
                    <mat-option
                      *ngFor="
                        let tag of tagsMap[
                          etrigger.get('project')?.value?.project_id
                        ]
                      "
                      [value]="tag"
                    >
                      {{ tag }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field
                  class="d2c-field"
                  *ngIf="
                    etrigger.get('trigger_by_pipeline_or_tags')?.value ===
                    'pipeline'
                  "
                >
                  <mat-label>Nodes</mat-label>
                  <mat-select
                    formControlName="user_input_nodes"
                    multiple
                    [compareWith]="compareNodesById"
                  >
                    <mat-optgroup
                      *ngFor="let pipeline of getPipelinesOrTags(etrigger)"
                      [label]="pipeline.pipeline_name"
                    >
                      <mat-option
                        *ngFor="
                          let node of filterNodesByPipeline(
                            pipeline.pipeline_id
                          )
                        "
                        [value]="node"
                      >
                        {{ node?.node_name }}
                      </mat-option>
                    </mat-optgroup>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="d2c-field">
                  <mat-label>Dataset</mat-label>
                  <mat-select formControlName="dataset">
                    <mat-option
                      *ngFor="let data of usedDatasetsInVersion"
                      [value]="data.data_name"
                    >
                      {{ data.data_name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="d2c-field">
                  <mat-label>Method</mat-label>
                  <mat-select formControlName="api_method">
                    <mat-option value="POST"> POST</mat-option>
                    <mat-option value="DELETE"> DELETE</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>

          <button class="btn-ghost" (click)="addEventTriggers()">
            <mat-icon>add</mat-icon>
            Add trigger
          </button>
        </form>
      </div>
    </section>
  </div>

  <!-- live preview -->
  <aside class="cfg-pv" aria-label="Customer preview">
    <div class="pv-label"><span class="dot"></span>Live preview — what the customer sees</div>
    <div class="pvframe">
      <div class="pv-chrome">
        <span class="c"></span><span class="c"></span><span class="c"></span>
        <span class="t">Configure &amp; run</span>
      </div>
      <div class="pv-body">
        <div class="pv-h">
          <h4>{{ activeSolution['solution_name'] }}</h4>
          <span class="d2c-version-chip">{{ activeVersion['version_name'] }}</span>
        </div>
        <div class="pv-sub">
          Answer these once — answers are saved for future runs.
        </div>

        <ng-container *ngIf="step2Rows.length">
          <div class="pv-sect">Map your columns</div>
          <div class="pv-q" *ngFor="let q of step2Rows">
            <span class="ql">{{ q.question || '(untitled question)' }}</span>
            <select disabled>
              <option>
                Choose a column from {{ q.datasetname || 'their data' }}…
              </option>
            </select>
            <div class="qh" *ngIf="q.datasetname">
              From the customer's <b>{{ q.datasetname }}</b> upload
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="step3Rows.length">
          <div class="pv-sect">Run settings</div>
          <div class="pv-q" *ngFor="let q of step3Rows">
            <span class="ql">{{ q.prompt || '(untitled prompt)' }}</span>
            <ng-container [ngSwitch]="q.fieldType">
              <input *ngSwitchCase="'date'" type="date" disabled />
              <select *ngSwitchCase="'single-select-string'" disabled>
                <option>Choose one…</option>
              </select>
              <select *ngSwitchCase="'multi-select-string'" disabled>
                <option>Choose one or more…</option>
              </select>
              <input
                *ngSwitchDefault
                type="text"
                placeholder="Customer types an answer…"
                disabled
              />
            </ng-container>
            <div class="qh" *ngIf="q.node">
              <span class="bchip"
              >{{ getNodeName(q.node) || 'node' }} → {{ fieldLabel(q.field) }}</span
              >
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="scheduleQuestions.length">
          <div class="pv-sect">Automation</div>
          <div class="pv-q" *ngFor="let q of scheduleQuestions">
            <span class="ql">{{ q }}</span>
            <select disabled>
              <option>Yes — run on schedule</option>
            </select>
          </div>
        </ng-container>

        <div
          class="pv-empty"
          *ngIf="!step2Rows.length && !step3Rows.length && !scheduleQuestions.length"
        >
          Add questions in steps 2–4 and they'll appear here exactly as the
          customer sees them.
        </div>

        <div class="pv-run">
          <button class="btn-ghost btn-sm" disabled>Save answers</button>
          <button class="btn-primary btn-sm" disabled>Save &amp; run</button>
        </div>
      </div>
    </div>
  </aside>
</div>

<!-- ===================== footer ===================== -->
<div class="cfg-f">
  <span class="cfg-f-note">Steps 4–5 are optional · closing asks before discarding changes</span>
  <span class="cfg-f-spacer"></span>
  <button class="btn-ghost" (click)="closeDialogForm()">Cancel</button>
  <button
    class="btn-primary"
    [disabled]="validateFormData() || eventTriggerForm.invalid"
    [mat-dialog-close]="true"
    (click)="save()"
  >
    {{ data?.formData ? 'Update' : 'Save' }}
  </button>
</div>
